import React, { Component } from "react";
import { Container } from "reactstrap";
import { RouterProps, Styled } from "../../../../toolkit/decorators/Artifact";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfig } from "./Snapshot.form";
import { MemoTable } from "./Snapshot.table";
import { SnapshotResumen } from "./SnapshotResumen.cards";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import FormBuilderModal from "../../common/formBuilderModal/formBuilderModal";
import { cambiarVendedorFormConfig } from "./SnapshotVendedor.form";
import { gestionFormConfig } from "./SnapshotGestion.form";
import { SnapshotDispatcher } from "../../../containers/comisionesMembresia/snapshot/Snapshot.dispatcher";
import { SnapshotStore } from "../../../containers/comisionesMembresia/snapshot/Snapshot.store";
import MembresiaSnapshot from "../../../../types/MembresiaSnapshot";
import {
  errorNotification,
  infoNotification,
  successNotification
} from "../../../../utils/notifications";
import { Preview } from "../../../../types/IAction";
import { GetSnapshot } from "../../../reducers/comisionMembresia";
import {
  downloadSnapshotByAsesor,
  downloadSnapshotByFolioFactura,
  downloadSnapshotByPeriodo
} from "../../../actions/comisionMembresia";
import ConfirmModal from "../../common/confirmModal/confirmModal";
import s from "./styles.scss";

interface Props extends SnapshotDispatcher, SnapshotStore, RouterProps {}

interface State {
  downloading: boolean;
  tipoBusqueda: string;
  filters: Inputs & {
    periodo: string;
    page: number;
    size: number;
  };

  row: MembresiaSnapshot;
  actualizarPopupOpen: boolean;
  cambiarVendedorPopupOpen: boolean;
  descartarPopupOpen: boolean;
  tiposMembresiaOpciones: Array<{ label: string; value: string }>;
  currentTipoOperacion: string;
}

@Styled(s)
export default class SnapshotComponent extends Component<Props, State> {
  state = {
    downloading: false,
    tipoBusqueda: "",
    filters: {
      periodo: null,
      page: 0,
      size: 100
    } as any,
    currentResumen: null,

    row: null as MembresiaSnapshot,
    actualizarPopupOpen: false,
    cambiarVendedorPopupOpen: false,
    descartarPopupOpen: false,
    tiposMembresiaOpciones: [],
    currentTipoOperacion: null
  };

  componentDidMount(): void {
    this.props.clearSnapshot();
    this.props.clearResumen();
  }

  clear = () => {
    this.setState({
      tipoBusqueda: "",
      filters: {
        page: 0,
        size: 100
      } as any
    });
  };

  fetchData = async ({ page, pageSize }) => {
    const { tipoBusqueda, filters } = this.state;
    const params = {
      ...filters,
      page,
      size: pageSize
    };

    let preview: Preview<GetSnapshot>;

    if (!tipoBusqueda) {
      preview = await this.props.getSnapshotByPeriodo(
        params.periodo,
        params.idClub,
        params.tipoOperacion,
        params.conCambios,
        params.evaluadorModifico,
        params.sinCumplimiento,
        params.page,
        params.size
      );
    } else if (tipoBusqueda === "factura") {
      preview = await this.props.getSnapshotByFolioFactura(
        params.folioFactura,
        params.page,
        params.size
      );
    } else {
      preview = await this.props.getSnapshotByAsesor(
        params.periodo,
        params.idVendedor,
        params.page,
        params.size
      );
    }

    if (!preview.fulfilled) {
      errorNotification(preview.gettingSnapshotError);
    }
  };

  submit = (data: { [key in Inputs]: any }) => {
    this.setState(
      {
        tipoBusqueda: data.tipoBusqueda,
        filters: {
          ...data,
          periodo: `${data.anio || new Date().getFullYear()}-${data.mes}-01`,
          page: 0,
          size: 100
        } as any
      },
      () => this.fetchData({ page: 0, pageSize: 100 })
    );
  };

  handleExport = async () => {
    const { tipoBusqueda, filters } = this.state;
    this.setState({ downloading: true });

    if (!tipoBusqueda) {
      downloadSnapshotByPeriodo(
        filters.periodo,
        filters.idClub,
        filters.tipoOperacion,
        filters.conCambios,
        filters.evaluadorModifico,
        filters.sinCumplimiento,
        () => this.setState({ downloading: false })
      );
    } else if (tipoBusqueda === "factura") {
      downloadSnapshotByFolioFactura(filters.folioFactura, () =>
        this.setState({ downloading: false })
      );
    } else {
      downloadSnapshotByAsesor(filters.periodo, filters.idVendedor, () =>
        this.setState({ downloading: false })
      );
    }
  };

  handleActualizarSnapshot = async (row: MembresiaSnapshot) => {
    this.setState({
      actualizarPopupOpen: true,
      row: row,
      currentTipoOperacion: row.tipoOperacion
    });

    // Cargar opciones iniciales según el tipo de operación de la fila
    if (row.tipoOperacion) {
      await this.loadTiposMembresiaOpciones(row.tipoOperacion);
    }
  };

  handleActualizarSubmit = async data => {
    const { row } = this.state;
    const preview = await this.props.putSnapshotEvaluacion(
      row.idCotizacionItem,
      {
        modo: data.modo,
        observaciones: data.observaciones,
        idMembresiaActualizacion: data.idMembresiaActualizacion
          ? parseInt(data.idMembresiaActualizacion as any)
          : null,
        tipoOperacionActualizacion: data.tipoOperacionActualizacion || null,
        ignorarMantenimiento: data.ignorarMantenimiento || false,
        ignorarExpediente: data.ignorarExpediente || false,
        ignorarMedioPago: data.ignorarMedioPago || false,
        ignorarMedioPagoDocumento: data.ignorarMedioPagoDocumento || false
      }
    );

    if (preview.fulfilled) {
      successNotification("La membresía se configuró correctamente");

      this.setState({
        actualizarPopupOpen: false,
        row: null
      });
      this.fetchData({
        page: this.state.filters.page,
        pageSize: this.state.filters.size
      });
    } else {
      errorNotification(preview.puttingSnapshotEvaluacionError);
    }
  };

  handleCambiarVendedor = (row: MembresiaSnapshot) => {
    this.setState({
      row,
      cambiarVendedorPopupOpen: true
    });
  };

  handleCambiarVendedorSubmit = async data => {
    const { row } = this.state;
    const preview = await this.props.putCambiarVendedor(row.idCotizacionItem, {
      idVendedor: parseInt(data.idVendedor as any),
      razonCambioVendedor: data.razonCambioVendedor
    });

    if (preview.fulfilled) {
      successNotification("Vendedor actualizado correctamente");

      this.setState({
        cambiarVendedorPopupOpen: false,
        row: null
      });
      this.fetchData({
        page: this.state.filters.page,
        pageSize: this.state.filters.size
      });
    } else {
      errorNotification(preview.puttingCambiarVendedorError);
    }
  };

  handleDescartarCambios = (row: MembresiaSnapshot) => {
    this.setState({
      row,
      descartarPopupOpen: true
    });
  };

  loadTiposMembresiaOpciones = async (tipoOperacion: string) => {
    if (!tipoOperacion) {
      this.setState({ tiposMembresiaOpciones: [] });
      return;
    }

    const preview = await this.props.getTiposMembresiaOpciones(tipoOperacion);
    if (preview.fulfilled) {
      this.setState({ tiposMembresiaOpciones: preview.tiposMembresiaOpciones });
    } else {
      errorNotification(preview.gettingTiposMembresiaOpcionesError);
      this.setState({ tiposMembresiaOpciones: [] });
    }
  };

  onGestionFormChange = async (values: any) => {
    // Cuando cambia el tipo de operación, recargar las opciones de membresía
    if (
      values.tipoOperacionActualizacion &&
      values.tipoOperacionActualizacion !== this.state.currentTipoOperacion
    ) {
      this.setState({
        currentTipoOperacion: values.tipoOperacionActualizacion
      });
      await this.loadTiposMembresiaOpciones(values.tipoOperacionActualizacion);
    }
  };

  handleDescartarConfirm = async () => {
    const { row } = this.state;
    const result = await this.props.deleteSnapshotEvaluacion(
      row.idCotizacionItem
    );

    if (result.fulfilled) {
      successNotification("Los cambios se descartaron correctamente");

      this.setState({
        descartarPopupOpen: false,
        row: null
      });
      this.fetchData({
        page: this.state.filters.page,
        pageSize: this.state.filters.size
      });
    } else {
      errorNotification(result.deletingSnapshotEvaluacionError);
    }
  };

  render() {
    const {
      row,
      actualizarPopupOpen,
      cambiarVendedorPopupOpen,
      descartarPopupOpen
    } = this.state;

    return (
      <Container>
        <FormBuilder<Inputs, Buttons>
          config={formConfig}
          submit={this.submit}
          processing={
            this.props.gettingSnapshot ||
            this.props.gettingResumenSnapshot ||
            this.props.postingSnapshotByPeriodo ||
            this.state.downloading
          }
        />

        {this.props.snapshot && (
          <MemoTable
            page={this.props.snapshot}
            loading={
              this.props.gettingSnapshot ||
              this.props.gettingResumenSnapshot ||
              this.props.postingSnapshotByPeriodo ||
              this.state.downloading
            }
            onFetchData={this.fetchData}
            onExport={this.handleExport}
            onActualizarSnapshot={this.handleActualizarSnapshot}
            onCambiarVendedor={this.handleCambiarVendedor}
            onDescartarCambios={this.handleDescartarCambios}
          />
        )}

        <FormBuilderModal
          isOpen={actualizarPopupOpen}
          title={`Actualizar Cotización ${!!row && row.idCotizacionItem}`}
          message={""}
          ok={this.handleActualizarSubmit}
          cancel={() => this.setState({ actualizarPopupOpen: false })}
          formConfig={gestionFormConfig}
          onChange={this.onGestionFormChange}
          values={{
            modo: (row && row.modo) || "",
            observaciones: (row && row.observaciones) || "",
            idMembresiaActualizacion:
              (row && row.idMembresiaActualizacion) || "",
            tipoOperacionActualizacion:
              (row && row.tipoOperacionActualizacion) || "",
            ignorarMantenimiento: (row && row.ignorarMantenimiento) || false,
            ignorarExpediente: (row && row.ignorarExpediente) || false,
            ignorarMedioPago: (row && row.ignorarMedioPago) || false,
            ignorarMedioPagoDocumento:
              (row && row.ignorarMedioPagoDocumento) || false
          }}
        >
          <ISelectBuilder
            name="idMembresiaActualizacion"
            data={this.state.tiposMembresiaOpciones}
          />
        </FormBuilderModal>

        <FormBuilderModal
          isOpen={cambiarVendedorPopupOpen}
          title={`Vendedor de Cotización ${!!row && row.idCotizacionItem}`}
          message={""}
          ok={this.handleCambiarVendedorSubmit}
          cancel={() => this.setState({ cambiarVendedorPopupOpen: false })}
          formConfig={cambiarVendedorFormConfig}
          values={{
            idVendedor: (row && row.idVendedor) || "",
            razonCambioVendedor: ""
          }}
        />

        <ConfirmModal
          isOpen={descartarPopupOpen}
          title={`Reestablecer Cotización ${!!row && row.idCotizacionItem}`}
          message={"Los cambios detectados y sus comentarios serán ignorados."}
          ok={this.handleDescartarConfirm}
          cancel={() => this.setState({ descartarPopupOpen: false })}
          size={"md"}
          waiting={this.props.deletingSnapshotEvaluacion}
        />
      </Container>
    );
  }
}
